import { createSlice } from '@reduxjs/toolkit';

type MenuInitialValues = {
    isOpen: boolean;
    type: string;
    status?: string;
    id?: number | null;
    payload?: any;
    title?: string;
    focus?: any;
};

const initialState: MenuInitialValues = {
    isOpen: false,
    type: '',
    status: '',
    id: null,
    payload: null,
    title: '',
    focus: null
};


const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        openMenu: (state, action) => {
            return { ...state, isOpen: true, ...action.payload };
        },
        closeMenu: (state) => {
            return { ...initialState };
        }
    }
});

export const { openMenu, closeMenu } = menuSlice.actions;

export default menuSlice.reducer;
